import { createContext } from 'react';

export interface User {
  id: string;
  email: string;
  full_name: string;
  profile_picture?: string;
  phone_number?: string;
  cpf?: string;
  last_login?: string;
  created_at: string;
  updated_at: string;
  is_active: boolean;
  is_system_admin: boolean;
  entities?: {
    id: string;
    name: string;
  }[];
}

interface AuthContextData {
  user: User | null;
  authenticated: boolean;
  loading: boolean;
  signOut: () => void;
  refreshUserToken: () => void;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

export default AuthContext;
